var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#social-instagram';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-social-instagram';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?social-instagram#social-instagram';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?social-instagram#view-social-instagram';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 13',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };